module.exports = __webpack_public_path__ + "img/clip-reading-of-books-1.48d858df.png";